import { Component, OnInit, Inject, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { State, orderBy } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { Customer, CustomerStatus, CustomerStatusChecklist, CustomerStatusChecklistMap, Employee } from '../../models/models';

@Component({
    selector: 'customer-status-checklist-old',
    templateUrl: './customer-status-checklist-old.component.html',
    standalone: false
})
export class EditCustomerStatusChecklistOLD implements OnInit, OnChanges, AfterViewInit {
    @Input() customerId: number = 0;
    @Input() customerStatusId: number = 0;
    @Input() customerActionId: number = 0;

    public selectedCustomerId: number = 0;
    public customer: Customer = { name: '' } as Customer;
    public customerStatuses: CustomerStatus[] = [];
    public customerStatusChecklists: CustomerStatusChecklist[] = [];
    public checklistMaps: CustomerStatusChecklistMap[] = [];
    public employees: Employee[] = [];
    public customerStatusGroup: UntypedFormGroup = new UntypedFormGroup({});
    public isCRMAdmin: boolean = false;

    public currentChecklist: CustomerStatusChecklist[] = [];

    @ViewChild('stepper', { static: false }) stepper: MatStepper | undefined;

    constructor(private crmService: CRMService, private formBuilder: UntypedFormBuilder, private employeeService: EmployeeService) { }

    ngOnInit() {
        this.isCRMAdmin = this.getIsCRMAdmin();
        this.getEmployees();
        this.getCustomerStatuses();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.customerId == null || changes.customerId.currentValue.toString() == '' || parseInt(changes.customerId.currentValue.toString()) < 1) return;

        this.selectedCustomerId = parseInt(changes.customerId.currentValue.toString());
        this.getCustomer();
        this.getChecklistMapsByCustomerId();
    }

    ngAfterViewInit() {
        this.stepper!._steps.changes.subscribe(() => {
            var customerStatus = this.customerStatuses.find(s => s.customerStatusId == this.customerStatusId);
            var ok = this.stepper!._steps.toArray();
            if (customerStatus != null) {
                for (var i = 1; i < customerStatus.stage; i++) {
                    this.stepper!.next();
                }
            }
        });

        this.stepper!.selectionChange.subscribe(indexChange => {
            if (this.customerStatusChecklists.length < 1) return;

            var sortDescriptor = { skip: 0, take: 200, sort: [{ dir: 'asc', field: 'stage' }] } as State;

            if (sortDescriptor.sort) {
                var ok = this.customerStatusGroup.controls;
                var customerStatus = this.customerStatuses.find(t => t.stage == indexChange.selectedIndex + 1)!;
                //this.currentChecklist = orderBy(this.customerStatusChecklists.filter(s => s.customerStatus.stage == (indexChange.selectedIndex + 1)), sortDescriptor.sort);
                this.currentChecklist = orderBy(this.customerStatusChecklists.filter(s => s.customerStatusId == customerStatus.customerStatusId), sortDescriptor.sort);
            }            
        });
    }

    getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    getCustomer() {
        this.crmService.getCustomerById(this.selectedCustomerId).subscribe(result => {
            this.customer = result;
        });
    }

    getCustomerStatuses() {
        this.crmService.getCustomerStatuses().subscribe(result => {
            this.customerStatuses = result;
            this.getCustomerStatusChecklists();
            this.buildStatusForm();
            this.setFormValues();
        });
    }

    getCustomerStatusChecklists() {
        this.crmService.getCustomerStatusChecklists().subscribe(result => {
            this.customerStatusChecklists = result;
            this.buildStatusForm();
            this.setFormValues();
        });
    }

    getChecklistByStatusId(customerStatusId: number): CustomerStatusChecklist[] {
        return this.customerStatusChecklists.filter(s => s.customerStatusId == customerStatusId);
    }

    getChecklistByStep(): CustomerStatusChecklist[] {
        if (this.stepper != null && this.stepper!.selectedIndex > 0) {
            var customerStatus = this.customerStatuses.find(t => t.stage == this.stepper!.selectedIndex + 1)!;
            //return this.customerStatusChecklists.filter(s => s.customerStatus.stage == (this.stepper!.selectedIndex + 1));
            return this.customerStatusChecklists.filter(s => s.customerStatusId == customerStatus.customerStatusId);
        }

        return [];
    }

    getChecklistMapsByCustomerId() {
        if (this.selectedCustomerId < 1) return;

        this.crmService.getCustomerStatusChecklistMapsByCustomerId(this.selectedCustomerId).subscribe(result => {
            this.checklistMaps = result;
            this.buildStatusForm();
            this.setFormValues();
        });
    }

    public getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    private buildStatusForm() {
        if (this.customerStatuses.length < 1 || this.customerStatusChecklists.length < 1) return;

        for (let status of this.customerStatuses) {
            var checklistGroup = new UntypedFormGroup({});
            var checklists = this.customerStatusChecklists.filter(s => s.customerStatusId == status.customerStatusId);

            for (let checklist of checklists) {
                checklistGroup.addControl(checklist.stage.toString() + 'Checkbox', new UntypedFormControl('', Validators.required));
                checklistGroup.addControl(checklist.stage.toString() + 'Text', new UntypedFormControl('', Validators.required));
            }

            this.customerStatusGroup.addControl(status.abbreviation, checklistGroup);
        }
    }

    private setFormValues() {
        if (this.customerStatuses.length < 1 || this.customerStatusChecklists.length < 1) return;

        for (let status of this.customerStatuses) {
            var statusGroup = this.customerStatusGroup.controls[status.abbreviation] as UntypedFormGroup;
            var checklists = this.customerStatusChecklists.filter(s => s.customerStatusId == status.customerStatusId);

            for (let checklist of checklists) {
                var listMap = this.checklistMaps.find(s => s.customerStatusChecklistId == checklist.customerStatusChecklistID);

                if (listMap != null) {
                    var checkboxCtrl = statusGroup.controls[checklist.stage.toString() + 'Checkbox'];
                    var textCtrl = statusGroup.controls[checklist.stage.toString() + 'Text'];

                    checkboxCtrl.setValue(listMap.completed);
                    textCtrl.setValue(listMap.notes);
                }
            }
        }
    }

    public saveChecklistMap(checklist: CustomerStatusChecklist) {
        var customerStatus = this.customerStatuses.find(t => t.customerStatusId == checklist.customerStatusId)!;
        var statusGroup = this.customerStatusGroup.controls[customerStatus.abbreviation] as UntypedFormGroup;

        if (!statusGroup) return;

        var checkboxCtrl = statusGroup.controls[checklist.stage.toString() + 'Checkbox'];

        if (!checkboxCtrl) return;

        var listMap = this.checklistMaps.find(s => s.customerStatusChecklistId == checklist.customerStatusChecklistID);
        var completed = statusGroup.controls[checklist.stage.toString() + 'Checkbox'].value as boolean;
        var notes = statusGroup.controls[checklist.stage.toString() + 'Text'].value.toString();

        if (!completed && notes.length < 1 && listMap != null) {
            this.crmService.deleteCustomerChecklistMap(listMap).subscribe(result => {
                this.getChecklistMapsByCustomerId();
            });
        }

        if (!completed || notes.length < 1) return;

        if (listMap == null) {
            listMap = {
                customerStatusChecklistMapID: 0,
                customerStatusChecklistId: checklist.customerStatusChecklistID,
                customerID: this.selectedCustomerId,
                createdByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!)
            } as CustomerStatusChecklistMap;
        } else {
            listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
        }

        if (listMap.notes == notes && listMap.completed == completed) return;

        listMap.completed = completed;
        listMap.notes = notes;

        this.crmService.saveCustomerStatusChecklistMap(listMap).subscribe(result => {
            var checklist = this.checklistMaps.find(c => c.customerStatusChecklistMapID == result.customerStatusChecklistMapID);

            if (checklist == null) {
                this.checklistMaps.push(result);
            } else {
                checklist.createdByEmployeeID = result.createdByEmployeeID;
            }
        });
    }

    public saveChecklists(customerStatus: CustomerStatus) {
        if (this.customerStatusChecklists.length < 1) return;

        var statusGroup = this.customerStatusGroup.controls[customerStatus.abbreviation] as UntypedFormGroup;
        var checklists = this.customerStatusChecklists.filter(s => s.customerStatusId = customerStatus.customerStatusId);

        if (checklists == null || checklists.length < 1) return;

        for (let checklist of checklists) {
            var listMap = this.checklistMaps.find(s => s.customerStatusChecklistId == checklist.customerStatusChecklistID);

            var checkboxCtrl = statusGroup.controls[checklist.stage.toString() + 'Checkbox'];

            if (!checkboxCtrl) continue;

            var completed = statusGroup.controls[checklist.stage.toString() + 'Checkbox'].value as boolean;
            var notes = statusGroup.controls[checklist.stage.toString() + 'Text'].value.toString();

            if (!completed || notes.length < 1) continue;

            if (listMap == null) {
                listMap = {
                    customerStatusChecklistMapID: 0,
                    customerStatusChecklistId: checklist.customerStatusChecklistID,
                    customerID: this.selectedCustomerId,
                    createdByEmployeeID: parseInt(localStorage.getItem('EmployeeId')!)
                } as CustomerStatusChecklistMap;
            } else {
                listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
            }

            listMap.completed = completed;
            listMap.notes = notes;

            this.crmService.saveCustomerStatusChecklistMap(listMap).subscribe(result => {
                var ok = result;
            });
        }
    }

    public getCompletedChecklistTimestamp(checklist: CustomerStatusChecklist) {
        var listMap = this.checklistMaps.find(c => c.customerStatusChecklistId == checklist.customerStatusChecklistID);

        if (listMap == null || listMap.customerStatusChecklistMapID < 1 || !listMap.completed) return '';

        var completedDate = new Date(listMap.completedDate);
        var employee = this.employees.find(e => e.employeeId == listMap!.createdByEmployeeID);

        return ' | Completed '
            + (completedDate.getMonth() + 1) + '/' + completedDate.getDate() + '/' + completedDate.getFullYear()
            + ' by ' + (employee == null ? '' : employee.fullName);
    }
}


@Component({
    selector: 'customer-status-checklist-dialog',
    templateUrl: './checklist-dialog.component.html',
    standalone: false
})
export class CustomerStatusChecklistDialog {
    constructor(public dialogRef: MatDialogRef<CustomerStatusChecklistDialog>, @Inject(MAT_DIALOG_DATA) public data: any) { }

    cancel(): void {
        this.dialogRef.close();
    }
}
